<template>
	<div>
		<Loader :show="loading" type="inline" />

		<div class="d-flex justify-content-between" v-if="!loading">
			<div>
				<h5 class="mb-0">Tickets</h5>
				<p class="text-secondary">
					Tickets vendidos para este evento.
				</p>
			</div>

			<div>
				<div class="filters-box justify-content-between">
					<div class="filter">
						<div class="filter-input">
							<i class="icon icon-search"></i>
							<input
								type="text"
								class="form-control"
								placeholder="Buscar en entradas"
								v-model="filters.search"
								@keyup.enter="updateFilters($event)"
							/>
							<div
								class="btn btn-light btn-clear-filter"
								v-if="filters.search"
								@click="
									filters.search = null
									updateFilters()
								"
							>
								<i class="icon icon-close"></i>
							</div>
						</div>
					</div>

					<b-dropdown no-caret right class="btn-dropdown-dots ml-2" v-if="canEdit">
						<template v-slot:button-content><i class="icon icon-dot-3"></i></template>
						<b-dropdown-item @click="$refs.ticketCourtesySend.open()">
							Enviar tickets de cortesía
						</b-dropdown-item>
					</b-dropdown>
				</div>
			</div>
		</div>
		<div class="card" v-if="!loading">
			<div class="card-body">
				<table class="table">
					<tr class="table-head">
						<td>Nombre</td>
						<td>Tipo</td>
						<td>Fecha de pago</td>
						<td>Monto</td>
					</tr>

					<tr v-for="item of list" :key="item.id">
						<td>
							<div class="tc" v-if="item.holder">
								<span class="bolder">{{ item.holder.name }} {{ item.holder.lastname }}</span>
								<span class="text-secondary">{{ item.holder.email }}</span>
							</div>
							<div class="tc" v-if="item.order && !item.holder">
								<span class="bolder">{{ item.order.user.name }} {{ item.order.user.lastname }}</span>
								<span class="text-secondary">{{ item.order.user.email }}</span>
							</div>
						</td>

						<td>
							<div class="tc">
								<span v-if="item.type == 'TICKET'"
									>Ticket
									{{
										item.ticketType.ticketGroup.holderRequired ? " personal" : " al portador"
									}}</span
								>
								<span v-if="item.type == 'COURTESY'">Cortesía</span>
								<span>{{ item.ticketType.ticketGroup.name }} - {{ item.ticketType.name }} </span>
							</div>
						</td>

						<td>
							<div class="tc">
								<span class="bolder" v-if="item.order"
									>{{ item.order.paidAt | moment("DD-MM-YYYY HH:mm") }}
								</span>
							</div>
						</td>
						<td>
							<div class="tc text-right">
								<span class="bolder">{{ item.currencySymbol }} {{ item.price | toCurrency }}</span>
							</div>
						</td>
					</tr>
				</table>

				<div class="alert alert-default text-center" v-if="!loading && list.length == 0">
					No se han encontrado tickets vendidos
				</div>
			</div>
		</div>

		<Pagination :pageData="pagination" @pageChange="pageChange" />

		<EventTicketCourtesyForm ref="ticketCourtesySend" :eventId="eventId" @updated="load()" />
	</div>
</template>

<script>
import gql from "graphql-tag"
import EventTicketCourtesyForm from "./EventTicketCourtesyForm"

export default {
	name: "EventTicketSellsTable",
	components: {
		EventTicketCourtesyForm
	},
	props: {
		eventId: {
			type: String
		}
	},
	data() {
		return {
			list: [],
			loading: true,
			canEdit: false
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String, $status: String, $eventId: ID) {
							tickets(take: $take, skip: $skip, search: $search, status: $status, eventId: $eventId) {
								data {
									id
									currencySymbol
									price
									type
									holder {
										id
										name
										lastname
										email
									}
									ticketType {
										id
										name
										ticketGroup {
											id
											name
											holderRequired
											event {
												canEdit
											}
										}
									}
									order {
										id
										paidAt
										user {
											id
											name
											lastname
											email
										}
									}
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search,
						status: "PAID",
						eventId: this.eventId
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.tickets.data
					this.pagination.pageInfo = data.tickets.pageInfo
					this.canEdit = data.tickets.data[0].ticketType.event.canEdit
					this.loading = false
				})
				.catch((err) => {
					this.loading = false
				})
		}
	}
}
</script>

<style></style>
